export default {
	expandableTitle: 'Valuations',
	labels: {
		average: '{source} Average',
		good: '{source} Clean',
		retail: '{source} Retail',
	},
	priceSource: {
		CAP: 'Source: CAP Live. Prices correct as of {date}',
		UKVD: `Source: Glass's. Prices correct as of {date}`,
	},
	sources: {
		CAP: 'CAP',
		UKVD: `Glass's`,
	},
};
